(function () {
	const addNotification = () => {
		const notifications = document.querySelectorAll('.notification');

		notifications.forEach((notification) => {
			const timeout = notification.dataset.timeout * 1000 || 0;
			const times = parseInt(notification.dataset.times || 0);
			const id = notification.dataset.id || 'default'; // Add `data-id` to uniquely identify each notification
			const localStorageKey = `notificationCounter_${id}`;
			let notificationShowedTimes = parseInt(localStorage.getItem(localStorageKey) || 0);

			const btn = notification.querySelector('.notification__btn');
			if (btn) {
				btn.addEventListener('click', () => {
					notification.classList.add('close');
				});
			}

			if (notificationShowedTimes < times) {
				setTimeout(() => {
					notification.classList.add('open');
				}, timeout);
				localStorage.setItem(localStorageKey, ++notificationShowedTimes);
			}

			// Subscribe popup logic (only runs if related popup exists)
			const addSubscribePopup = document.querySelector('.subscribe-popup-wrap');
			if (addSubscribePopup) {
				const elementToClick = notification.querySelector('.notification__wrapper');
				const subscribePopup = addSubscribePopup.querySelector('.promo-popup-subscribe');
				const emailInput = subscribePopup.querySelector('input[type="email"]');
				const closePopup = addSubscribePopup.querySelectorAll(".promo-popup-close, .overlay");

				if (elementToClick) {
					elementToClick.style.cursor = 'pointer';
					elementToClick.tabIndex = 0;

					const openPopup = () => {
						subscribePopup.classList.add('active');
						subscribePopup.style.visibility = 'visible';
						emailInput.focus();
					};

					elementToClick.addEventListener('click', openPopup);
					elementToClick.addEventListener('keydown', (event) => {
						if (event.key === "Enter" || event.key === " ") {
							openPopup();
							event.preventDefault();
						}
					});
				}

				closePopup.forEach((element) => {
					element.addEventListener('click', () => {
						subscribePopup.classList.remove('active');
						subscribePopup.style.visibility = 'hidden';
					});
					element.addEventListener('keydown', (event) => {
						if (event.key === "Enter" || event.key === " ") {
							subscribePopup.classList.remove('active');
							subscribePopup.style.visibility = 'hidden';
							event.preventDefault();
						}
					});
				});

				document.addEventListener('keydown', (event) => {
					if (event.key === "Escape" && subscribePopup.classList.contains('active')) {
						subscribePopup.classList.remove('active');
						subscribePopup.style.visibility = 'hidden';
					}
				});
			}
		});

		const form = document.getElementById("promo-popup-form");
		if (form) {
			form.addEventListener("submit", function (e) {
				if (!document.getElementById("accept_terms").checked) {
					e.preventDefault();
					alert("You must agree to the Terms and Privacy Policy to subscribe.");
				}
			});
		}
	};

	document.addEventListener('DOMContentLoaded', addNotification);
	document.addEventListener('shopify:section:load', addNotification);
})();
